import { RSimTable } from './Inventory/RSimTable';

import { RSimFilters } from './Filters/RSimFilters';
import { TableLayout } from 'common/components/Layouts/TableLayout/TableLayout';

import { RSimProductTagProvider } from 'rSimInventory/RSimTags/RSimProductTagProvider';
import { RSimFiltersURLParser } from './Filters/SearchParams/RSimFilterURLParser';

import { useTabNavigationSetter } from 'src/common/components/AppLayout/AppNavigation/hooks/useTabNavigationSetter';
import { productNavigationAtom } from 'src/atoms/pages/pages';
import { useRSimProductUrlFromFilters } from './hooks/useRSimUrlFromFilters';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';
import { RSimGraphs } from './Inventory/Graphs/RSimGraphs';
import { ProductsTabs } from 'src/products/layout/ProductsTabs';
import { styled } from '@mui/material/styles';
import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { ErrorFallbackRoot } from 'src/common/components/Fallbacks/ErrorFallback';
import { PageWithGraphs } from 'src/common/components/Layouts/PageLayout/PageWithGraphs';
import { TabsLayoutTabContent } from 'src/common/components/Layouts/TabsLayout/TabsLayout';
import { openProductGraphsContainer } from 'src/atoms/ui/graphs';
import { DEFAULT_BORDER_RADIUS } from 'src/theme/constants';
import { TableSkeletonContainer } from 'src/common/components/Table/TableSkeleton';
import { ExternalRowSelectionProvider } from 'common/components/ConfigurableTable/Components/Rows/ExternalRowSelection/ExternalRowSelectionProvider.tsx';
import { RSimProductsSelectionReset } from './Inventory/RSimProductsSelectionReset';

const RSimPageLayoutTabs = styled('div', { name: 'RSimPageLayout' })(({ theme }) => ({
  height: '100%',
  [`& ${TableSkeletonContainer}`]: {
    borderLeft: `1px solid ${theme.palette.border}`,
    borderRight: `1px solid ${theme.palette.border}`,
  },
  [`& ${TabsLayoutTabContent}`]: {
    border: 'none',
  },
  [`& ${ErrorFallbackRoot}`]: {
    border: `1px solid ${theme.palette.border}`,
    borderRadius: DEFAULT_BORDER_RADIUS,
  },
}));

const RSimNavigationSetter = () => {
  const url = useRSimProductUrlFromFilters();
  useTabNavigationSetter({ tabsAtom: productNavigationAtom, routeToSet: url });

  return null;
};

export const RSimInventoryTab = () => {
  const dashboardEnabled = useHasFeatureFlag('AnalyticsModule');

  return (
    <PageWithGraphs
      graphs={dashboardEnabled && <RSimGraphs />}
      slots={{
        graphsContainer: {
          openAtom: openProductGraphsContainer,
        },
      }}
    >
      <RSimPageLayoutTabs>
        <ProductsTabs>
          <TabPanelWithErrorHandling name={'rSIM'}>
            <RSimProductTagProvider>
              <ExternalRowSelectionProvider>
                <RSimProductsSelectionReset />
                <TableLayout showBorder>
                  <RSimFilters />
                  <RSimTable />
                </TableLayout>
              </ExternalRowSelectionProvider>
            </RSimProductTagProvider>
          </TabPanelWithErrorHandling>
        </ProductsTabs>
      </RSimPageLayoutTabs>
    </PageWithGraphs>
  );
};

export const RSimInventory = () => {
  return (
    <RSimFiltersURLParser>
      <RSimNavigationSetter />
      <RSimInventoryTab />
    </RSimFiltersURLParser>
  );
};
